import FormsActions from "@/components/forms/FormsActions";
import SelectFilterSpec from "@/server/com/silkplm/engine/forms/schema/definition/filters/SelectFilterSpec";
import CheckBoxFilterSpec from "@/server/com/silkplm/engine/forms/schema/definition/filters/CheckBoxFilterSpec";
import StreamSelection from "@/server/com/silkplm/rpc/dto/StreamSelection";
import ColorVersionBindingPlanning from "@/server/com/silkplm/model/plm/ColorVersionBindingPlanning";
import Product from "@/server/com/silkplm/model/plm/Product";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";

// #checkboxFilter
/**
 *
 * @param fieldConfig {SelectFormFieldConfig}
 * @param form
 * @param context
 * @param entitiesList
 * @param recordsWithChosenFilters
 * @param recordsWithChosenFiltersFromStreaming
 * @return {{selectedId, mergeTree: boolean}}
 */
export async function selectFilter(fieldConfig, form, context, entitiesList, recordsWithChosenFilters, recordsWithChosenFiltersFromStreaming) {
    let instances;
    let action;
    if (!fieldConfig.ignoreFilterOnGridFilters) {
        if (fieldConfig.joined || fieldConfig.viewClassShortId) {
            let fieldName;
            if (fieldConfig.joined) {
                fieldName = fieldConfig.fieldConfigId;
            } else {
                const lastUnderscoreIndex = fieldConfig.fieldName.lastIndexOf('_');
                fieldName = fieldConfig.fieldName.slice(lastUnderscoreIndex + 1);
                let showDifferentFieldOnGrid = form.fields.filter(field => field.onGridShowAsField === fieldName);
                if (showDifferentFieldOnGrid?.length) {
                    fieldName = showDifferentFieldOnGrid[0].fieldName.slice(lastUnderscoreIndex + 1);
                }
            }
            instances = await Rpc.Forms.listDictionaryValues(fieldConfig.sourceClass, fieldName, null);
        } else {
            let fieldName = fieldConfig.fieldName;
            let showDifferentFieldOnGrid = form.fields.filter(field => field.onGridShowAsField === fieldName);
            if (showDifferentFieldOnGrid?.length) {
                fieldName = showDifferentFieldOnGrid[0].fieldName;
            }
            instances = await Rpc.Forms.listDictionaryValues(form.formClassLong, fieldName, null);
        }
        let onlyIds = [];
        instances.forEach(instance => {
            onlyIds.push(instance.id);
        })
        action = await FormsActions.showMultiSelectListFromIds(fieldConfig.foreignClass, {}, onlyIds);
    } else {
        action = await FormsActions.showMultiSelectList(fieldConfig.foreignClass,
            {
                "recordsWithChosenFilters": null,
                "showDelete": false,
                "showAdd": false,
                "showDetails": false,
                "filteringMode": true
            });
    }
    let records = await action.getResult();

    if (!records || !records.length) {
        return [null, null];
    }
    if (records.materialize) {
        await records.materialize();
    }

    let spec = new SelectFilterSpec();
    spec.mergeTree = true;
    spec.idValues = records.map(el => el.id);
    return [spec, records];
}